import { getInnerRowSpan } from '@salescore/core'

// 展開時に表示する内部行の上限。展開したセルは全件 DOM に生成済みで行 div が overflow: hidden で切っているだけなので、
// この値を変えても DOM 量は変わらず「何行目まで到達できるか」だけが変わる。撤廃すると 1000 行目以降が新たに見えるようになり、
// 行の表示領域を実際の子レコード行数に合わせるという目的を超えて到達範囲そのものが変わるため、上限は残す。
const EXPANDED_ROW_LIMIT = 1000

/**
 * 親レコード行が占める内部行数を、表示行数制限と展開状態で切り詰める。
 * 行 div の高さと仮想スクロールの累積オフセットは同じ値でなければ行の下端がずれるため、両者はこの関数を共有する。
 *
 * 展開中は表示行数制限の設定値に関わらず EXPANDED_ROW_LIMIT が上限になり、非展開時のみ設定値で切る。
 * 非展開かつ visibleRowNumber が undefined は「全て表示」で、その解釈もここに閉じる。
 */
export const clampRowInnerRowSpan = ({
  record,
  visibleRowNumber,
  expanded,
}: {
  record: { meta: { innerRowIndexStart: number; innerRowIndexEnd: number } }
  visibleRowNumber: number | undefined
  expanded: boolean
}): number => {
  const innerRowSpan = getInnerRowSpan(record)
  return Math.min(innerRowSpan, expanded ? EXPANDED_ROW_LIMIT : (visibleRowNumber ?? innerRowSpan))
}
